import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientUserRelationship, ProfessionalUserRelationShip, UserTypeEnum } from '@app/enum/UserTypeEnum';
import { relationshipStoreActions, RootStoreState } from '@app/root-store';
import { RelationshipStoreEffects } from '@app/root-store/relationship-store/effects';
import { UserConnectionService, UserService } from '@app/shared/services';
import { InviteService } from '@app/shared/services/invite/invite.service';
import { OfficeService } from '@app/shared/services/office/office.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { userType } from '@app/root-store/notification-store/notification.model';
import { environment } from '@env/environment';
import { SharedConfirmationDialogComponent } from '../shared-confirmation-dialog/shared-confirmation-dialog.component';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'user-invite',
  templateUrl: './user-invite.component.html',
  // styleUrls: ['./user-invite.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInviteComponent implements OnInit, OnDestroy {
  @Output() public onInviteComplete: EventEmitter<any> = new EventEmitter();

  @ViewChild('inviteFormDirective', { static: true })
  removedLiAssignfamilylicense = false;
  isPrefessional: boolean = false;
  hideRelationship: boolean = false;
  inviteForm: UntypedFormGroup;
  isPrefessionalLogin;
  current_user;
  connection_relationship_data: any = {};
  allRelationship = [];
  allInvites = [];
  relationshipObject$;
  relationshipObject;
  disableSelectionOption = false;
  hideUserInpitePopup = false;
  hideText: boolean = true;
  subscription: Subscription = new Subscription();
  permissionOptions = ['Yes', 'No'];
  isPaymentFeatureEnabled: boolean = environment.isPaymentFeatureEnabled;

  constructor(
    private _fb: UntypedFormBuilder,
    private _inviteService: InviteService,
    private toastr: ToastrService,
    public activeModal: NgbActiveModal,
    private userConnectionService: UserConnectionService,
    private dialog: MatDialog,
    private store$: Store<RootStoreState.State>,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private relationshipService: RelationshipStoreEffects,
    private dialogRef: MatDialogRef<UserInviteComponent>,
    private officeService: OfficeService,
    private _store: Store,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.relationshipObject$ = this.relationshipService.relationshipObject;
    this.subscription.add(
      this.relationshipObject$.subscribe((data) => {
        this.allInvites = data['allInvites'];
        this.allRelationship = data['allRelationships'];
      })
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }
  ngOnInit() {
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((data) => {
        if (data) {
          this.current_user = data;
          if (this.current_user?.user_type == UserTypeEnum.Professional) {
            this.isPrefessionalLogin = true;
          } else {
            this.isPrefessionalLogin = false;
          }
        } else {
          this.current_user = null;
        }
      })
    );

    this.inviteForm = this._fb.group({
      first_name: ['', [Validators.required, noWhitespaceValidator()]],
      last_name: ['', [Validators.required, noWhitespaceValidator()]],
      notes: [''],
      assignFamilylicense: [false],
      inviteEmail: ['', [Validators.required, emailValidator()]],
      inviteRelationshipId: [0],
      relationship_id: ['', [Validators.required]],
      relationship_name: ['', [Validators.required, noWhitespaceValidator()]],
      userType: [''],
      isUserAddedToLicense: [''],
      your_self: [null],
    });

    // Prefill form with data from Contact Details if available
    if (this.data?.firstName || this.data?.lastName || this.data?.email) {
      const prefillValues: any = {};
      if (this.data.firstName) {
        prefillValues.first_name = this.data.firstName;
      }
      if (this.data.lastName) {
        prefillValues.last_name = this.data.lastName;
      }
      if (this.data.email) {
        prefillValues.inviteEmail = this.data.email;
      }
      this.inviteForm.patchValue(prefillValues);
    }

    this.subscription.add(
      this.inviteForm.get('notes').valueChanges.subscribe((value) => {
        if (value && value.startsWith(' ')) {
          this.inviteForm.get('notes')?.setValue(value.trimStart(), { emitEvent: false });
        }
      })
    );

    if (this.isPaymentFeatureEnabled) {
      this.inviteForm.controls['userType'].addValidators([Validators.required]);
    }

    if (this.data?.user_type) {
      this.inviteForm.controls['userType'].setValue(this.data?.user_type);
    } else if (this.isPrefessionalLogin) {
      this.inviteForm.controls['userType'].setValue('Professional');
    } else if (!this.isPrefessionalLogin) {
      // this.inviteForm.controls['userType'].setValue('Family');
    }
  }

  onUserTypeChange(event: any) {
    const selectedValue = event.value;
    if (selectedValue === 'Family' && this.isPaymentFeatureEnabled) {
      this.inviteForm.controls['isUserAddedToLicense'].addValidators([Validators.required]);
      this.inviteForm.controls['isUserAddedToLicense'].setValue('');
    } else if (this.current_user?.user_type === 'Standard') {
      this.inviteForm.controls['isUserAddedToLicense'].setValue('No');
    } else {
      this.inviteForm.controls['isUserAddedToLicense'].setValue('');
    }
  }

  relationshipIdChanged(id) {
    this.inviteForm.controls['inviteRelationshipId'].setValue(id);
  }

  public doSomething(data: any): void {
    if (data['invalid'] == true) {
      this.inviteForm.controls['relationship_id'].setValue('');
      this.inviteForm.controls['relationship_name'].setValue('');
    } else {
      this.inviteForm.controls['relationship_id'].setValue(data['id']);
      this.inviteForm.controls['relationship_name'].setValue(data['name']);
    }
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  sendInvite() {
    this.markFormGroupTouched(this.inviteForm);
    if (!this.inviteForm.valid) {
      return;
    }

    this.cd.detectChanges();
    if (this.inviteForm.controls['inviteEmail'].value === this.current_user.email) {
      return;
    }

    if (this.inviteForm.invalid) {
      return;
    }

    let index;
    if (this.allRelationship != null) {
      index = this.allRelationship.findIndex((x) => x.user_email == this.inviteForm.controls.inviteEmail.value?.toLowerCase());
      if (index != -1) {
        if (this.allRelationship[index].connection_status == 'approved') {
          this.toastr.error('You are already connected to this user.');
        } else {
          this.toastr.error('You already have a pending invite to this email.');
        }

        return;
      }
    }

    if (this.allInvites != null) {
      index = this.allInvites.findIndex((x) => x.email == this.inviteForm.controls.inviteEmail.value?.toLowerCase());
      if (index != -1) {
        this.toastr.error('You already have a pending invite to this email.');
        return;
      }
    }

    this.subscription.add(
      this.userConnectionService
        .checkUserIsAlreadyintheSystem({
          email: this.inviteForm.controls.inviteEmail.value?.toLowerCase(),
        })
        .subscribe(
          (res) => {
            if (res == undefined) {
              const data = {
                user_id: this.current_user.id,
                first_name: this.inviteForm.controls['first_name'].value ? this.inviteForm.controls['first_name'].value : '',
                last_name: this.inviteForm.controls['last_name'].value ? this.inviteForm.controls['last_name'].value : '',
                to_name: `${this.inviteForm.controls['first_name'].value + ' ' + this.inviteForm.controls['last_name'].value}` || '',
                email: this.inviteForm.controls['inviteEmail'].value ? this.inviteForm.controls['inviteEmail']?.value.toLowerCase() : '',
                relationship_id: this.inviteForm.controls['relationship_id'].value ? this.inviteForm.controls['relationship_id'].value : '',
                relationship_name: this.inviteForm.controls['relationship_name'].value ? this.inviteForm.controls['relationship_name'].value : '',
                notes: this.inviteForm.controls['notes'].value ? this.inviteForm.controls['notes'].value : '',
                user_type:
                  this.inviteForm.controls['userType'].value && !this.data?.isSharedVault
                    ? this.inviteForm.controls['userType'].value == 'Family' || this.inviteForm.controls['userType'].value == 'viewOnly'
                      ? ''
                      : this.inviteForm.controls['userType'].value
                    : '',
                isUserAddedToLicense: this.inviteForm.controls['isUserAddedToLicense'].value
                  ? this.inviteForm.controls['isUserAddedToLicense'].value
                  : 'No',
                your_self:
                  !this.inviteForm.controls['your_self'].value || this.inviteForm.controls['your_self'].value.trim() === ''
                    ? null
                    : this.inviteForm.controls['your_self'].value,
                is_view_only: this.inviteForm.controls['userType'].value == 'viewOnly' ? true : false,
              };

              this.subscription.add(
                this._inviteService.createInvite(data).subscribe(
                  (res) => {
                    if (res) {
                      this.officeService.selectClient(res);
                    }
                    const inviteUserConnection = {
                      requested_user_id: res.id,
                      status: 'invited',
                      relationship_id: data.relationship_id,
                    };

                    this.subscription.add(
                      this.userConnectionService.connectToUser(inviteUserConnection).subscribe((conn) => {
                        //connection created, now send e-mail
                        this.store$.dispatch(new relationshipStoreActions.AllRelationships());
                        this.toastr.success('Invite Sent');
                        this.onInviteComplete.emit();
                        const closeData = {
                          user: res,
                          isexistingUser: false,
                          success: true,
                          FullName: `${this.inviteForm.controls['first_name'].value + ' ' + this.inviteForm.controls['last_name'].value}` || '',
                          email: this.inviteForm.controls['inviteEmail'].value ? this.inviteForm.controls['inviteEmail'].value?.toLowerCase() : '',
                          isPrefessional: this.inviteForm.controls['userType'].value ? true : false,
                          relationship_name: this.inviteForm.controls['relationship_name'].value
                            ? this.inviteForm.controls['relationship_name'].value
                            : '',
                          isUserAddedToLicense: this.inviteForm.controls['isUserAddedToLicense'].value
                            ? this.inviteForm.controls['isUserAddedToLicense'].value
                            : 'No',
                        };
                        this.dialogRef.close(closeData);
                      })
                    );
                  },
                  (error) => {}
                )
              );
              this.cd.detectChanges();
            } else {
              const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
                width: '400px',

                data: {
                  title: 'User already exists',
                  materialIcon: 'info_outline',
                  text: 'The user already exists, would you like to send them a Connection Request?',
                  proceedTitle: `Proceed`,
                },
              });
              this.subscription.add(
                dialogRef.afterClosed().subscribe((confirmationData) => {
                  const { isCancel, confirmation } = confirmationData;
                  if (isCancel) {
                    return;
                  }
                  // this.dialogRef.close();
                  if (confirmation) {
                    this.sendRelationShipRequest(res, true);
                  }
                })
              );
            }
          },
          (error) => {
            this.cd.detectChanges();
          }
        )
    );
  }

  sendRelationShipRequest(res, isExistingUser = false) {
    const data = {
      to_user_id: res.id,
      requested_user_id: res.id,
      user_id: this.current_user.id,
      email: this.inviteForm.controls['inviteEmail'].value ? this.inviteForm.controls['inviteEmail'].value?.toLowerCase() : '',
      relationship_id: this.inviteForm.controls['relationship_id'].value ? this.inviteForm.controls['relationship_id'].value : '',
      relationship_name: this.inviteForm.controls['relationship_name'].value ? this.inviteForm.controls['relationship_name'].value : '',
      notes: this.inviteForm.controls['notes'].value ? this.inviteForm.controls['notes'].value : '',
      isUserAddedToLicense: this.inviteForm.controls['isUserAddedToLicense'].value ? this.inviteForm.controls['isUserAddedToLicense'].value : 'No',
      user_type:
        this.inviteForm.controls['userType'].value && !this.data?.isSharedVault
          ? this.inviteForm.controls['userType'].value == 'Family'
            ? ''
            : this.inviteForm.controls['userType'].value
          : '',
    };
    if (isExistingUser) {
      (data as any).status = 'approved';
    }
    this.subscription.add(
      this.userConnectionService.connectToUser(data).subscribe(
        (finalres) => {
          this.store$.dispatch(new relationshipStoreActions.AllRelationships());
          this.onInviteComplete.emit();
          const closeData = {
            user: res,
            isexistingUser: true,
            success: true,
            FullName: `${this.inviteForm.controls['first_name'].value + ' ' + this.inviteForm.controls['last_name'].value}` || '',
            email: this.inviteForm.controls['inviteEmail'].value ? this.inviteForm.controls['inviteEmail'].value?.toLowerCase() : '',
            isPrefessional: this.inviteForm.controls['userType'].value ? true : false,
            relationship_name: this.inviteForm.controls['relationship_name'].value ? this.inviteForm.controls['relationship_name'].value : '',
            isUserAddedToLicense: this.inviteForm.controls['isUserAddedToLicense'].value
              ? this.inviteForm.controls['isUserAddedToLicense'].value
              : 'No',
            user_type:
              this.inviteForm.controls['userType'].value && !this.data?.isSharedVault
                ? this.inviteForm.controls['userType'].value == 'Family'
                  ? ''
                  : this.inviteForm.controls['userType'].value
                : '',
          };
          this.dialogRef.close(closeData);
        },
        (error) => {}
      )
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
export function emailValidator() {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value;

    // Check for empty string (after trimming)
    if (email.trim() === '') {
      return { required: true }; // or any other error key
    }

    // Regular expression to validate email (with whitespace allowed)
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,25}$/;

    // Validate the email pattern
    if (!emailPattern.test(email.replace(/\s/g, ''))) {
      return { invalidEmail: true }; // or any other error key
    }

    return null; // No errors
  };
}
export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  };
}
